// Custom cursor
const cur = document.getElementById('cur');
const ring = document.getElementById('curRing');
if (cur && ring) {
document.addEventListener('mousemove', e => {
cur.style.left = e.clientX + 'px';
cur.style.top = e.clientY + 'px';
setTimeout(() => {
ring.style.left = e.clientX + 'px';
ring.style.top = e.clientY + 'px';
}, 80);
});
}
// Scroll reveal
document.querySelectorAll('.reveal').forEach(el => {
new IntersectionObserver(([entry]) => {
if (entry.isIntersecting) entry.target.classList.add('visible');
}, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }).observe(el);
});
// Nav scroll bg
const nav = document.querySelector('.ftt-nav');
if (nav) {
window.addEventListener('scroll', () => {
nav.style.background = window.scrollY > 80
? 'rgba(9,9,9,0.97)'
: 'linear-gradient(to bottom, rgba(9,9,9,0.95), transparent)';
});
}
// Email form
window.fttSubmitEmail = function() {
const input = document.getElementById('fttEmailInput');
if (!input || !input.value.includes('@')) return;
const toast = document.getElementById('fttToast');
if (toast) {
toast.classList.add('show');
setTimeout(() => toast.classList.remove('show'), 4000);
}
input.value = '';
};